export default __webpack_public_path__ + "static/ac1bd1b2227ebce65427ed7bf10c5ac4.jpg";